import { createRestApiClient } from '..';
import { getCategoryKey, getUserToken, getWebUserId } from '../../Utils/helper';
import { getWebUserType } from '../../Utils/getWebUserType';
import { get } from 'js-cookie';

export const tabByKeyFetcher = (params) => {
  const restApiClient = createRestApiClient();
  return restApiClient
    .request({
      method: 'GET',
      url: 'new/generalTab/getTabByKeyForWeb',
      params: params,
    })
    .then((res) => res.data);
};

export const categoryNavBarDataFetcher = () => {
  const restApiClient = createRestApiClient();
  return restApiClient
    .request({
      method: 'GET',
      url: 'new/generalTab/getCategoryDataForStoreHomeWeb',
      params: {
        'Mylo-In-App': false,
        'userType': 'A',
      },
    })
    .then((res) => res?.data);
};

export const categorySideBarDataFetcher = (term_id = '') => {
  const restApiClient = createRestApiClient();
  const url = `api/getTopicListV3?key=${term_id}&type=category`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: {
        userType: getWebUserType(),
      },
      headers: {
        'authorization': getUserToken(true),
        'Mylo-In-App': false,
      },
    })
    .then((res) => res?.data);
};

export const getCartDetails = () => {
  const restApiClient = createRestApiClient();
  const url = `api/getCartDetails`;
  let params = {
    web_user_id: getWebUserId(),
  };
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
};
export const GetSubCategoriesData = (categoryId, isL0Category = false) => {
  const restApiClient = createRestApiClient();
  const url = `new/generalTab/getL2L3ForL1Category?categoryId=${categoryId}&forL0Category=${isL0Category}`;
  return restApiClient
    .request({
      method: 'GET',
      url: url,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
};

const getSubCategoriesFromActualData = async (
  categoryNavBarData,
  webUrl,
  categoryStaticData,
) => {
  let subCategories = [];
  categoryNavBarData.forEach((element) => {
    if (element?.subCategories?.length) {
      let itemindex = -1;
      if (
        categoryStaticData?.data?.tagStage === 3 ||
        categoryStaticData?.data?.tagStage === 1
      ) {
        element.subCategories.forEach((item) => {
          let l2element = item;
          itemindex = l2element?.subCategories?.findIndex(
            (item) => parseInt(item._id) == getCategoryKey(webUrl),
          );
          if (itemindex != -1) {
            subCategories.push(element.subCategories);
          }
        });
      } else {
        itemindex = element.subCategories?.findIndex(
          (item) => parseInt(item._id) == getCategoryKey(webUrl),
        );
        if (itemindex != -1) {
          subCategories.push(element.subCategories);
        }
      }
    }
  });
  return subCategories[0];
};

const getUniqueListBy = (arr, key) => {
  return [...new Map(arr.map((item) => [item[key], item])).values()];
};
// export const getBreadCrumbsData = async (
//     subCategoriesData,
//     categoryData,
//     webUrl,
// ) => {
//     const actualSubCategoryData = await getSubCategoriesFromActualData(
//         subCategoriesData,
//         webUrl,
//         categoryData,
//     );
//     let breadCrumbsData = [];
//     breadCrumbsData.push({
//         name: "Home",
//         deeplinkValue: getPublicUrl(),
//     });
//     let itemToAdd = {};
//     const categoryStage = categoryData?.data?.tagStage;
//     if (actualSubCategoryData?.length) {
//         for (let index = 0; index < actualSubCategoryData?.length; index++) {
//             if (index == 0) {
//                 breadCrumbsData.push({
//                     name: actualSubCategoryData[index].tabName,
//                     deeplinkValue: actualSubCategoryData[index].key,
//                 });
//                 let itemindex = "";
//                 if (categoryStage === 3 || categoryStage === 1) {
//                     itemindex = actualSubCategoryData[
//                         index
//                     ].subCategories?.findIndex(
//                         (item) => parseInt(item._id) == getCategoryKey(webUrl),
//                     );
//                 } else if (categoryStage === 2) {
//                     itemindex = actualSubCategoryData.findIndex(
//                         (item) => parseInt(item._id) == getCategoryKey(webUrl),
//                     );
//                 }
//                 if (itemindex != -1) {
//                     if (categoryStage === 3 || categoryStage === 1) {
//                         breadCrumbsData.push({
//                             name: actualSubCategoryData[index]?.subCategories[
//                                 itemindex
//                             ]?.tabName,
//                             deeplinkValue: actualSubCategoryData[index].key,
//                         });
//                         break;
//                     } else if (categoryStage === 2) {
//                         breadCrumbsData.push({
//                             name: actualSubCategoryData[itemindex]?.tabName,
//                             deeplinkValue: actualSubCategoryData[itemindex].key,
//                         });
//                         break;
//                     }
//                 }
//             } else {
//                 let itemindex;
//                 itemToAdd["name"] = actualSubCategoryData[index].tabName;
//                 itemToAdd["deeplinkValue"] = actualSubCategoryData[index].key;
//                 itemindex = actualSubCategoryData[
//                     index
//                 ].subCategories?.findIndex(
//                     (item) => parseInt(item._id) == getCategoryKey(webUrl),
//                 );
//                 if (itemindex != -1) {
//                     breadCrumbsData.push(itemToAdd);
//                     breadCrumbsData.push({
//                         name: actualSubCategoryData[index]?.subCategories[
//                             itemindex
//                         ]?.tabName,
//                     });
//                     break;
//                 }
//             }
//         }
//     } else {
//         breadCrumbsData.push({
//             name: categoryData?.data?.tabName,
//             deeplinkValue: categoryData?.data?.key,
//         });
//     }
//     const finalData = getUniqueListBy(breadCrumbsData, "name");
//     delete finalData[finalData.length - 1]?.deeplinkValue;
//     return finalData;
// };

export const getBreadCrumbsJSONldData = (data) => {
  let JSONLD = [];
  data.forEach((element, index) => {
    let obj = {
      position: index + 1,
      name: element?.name,
      item: element?.deeplinkValue,
    };
    JSONLD.push(obj);
  });
  return JSONLD;
};
